<template>
    <div style="height:100%;"> 
        <title>会员列表</title>
        <div class="mainPart">
            <!-- S头部搜索区域 -->
            <el-form :inline="true" :model="searchClsForm" class="searchForm">
              <el-form-item label="关键词">
                  <el-input v-model="searchClsForm.keyword" clearable placeholder="请输入内容"></el-input>
              </el-form-item>
              <el-form-item label="状态" class="formTimeSlot">
                  <el-select v-model="searchClsForm.status" placeholder="请选择" clearable>
                    <el-option label="启用" :value="1"></el-option>
                    <el-option label="禁用" :value="0"></el-option>
                  </el-select>
              </el-form-item>
                    <!-- <el-form-item label="会员使用范围">
                  <el-select v-model="searchClsForm.usetype" placeholder="请选择" clearable>
                    <el-option label="外部使用" value="1"></el-option>
                    <el-option label="内部使用" value="0"></el-option>
                  </el-select>
              </el-form-item> -->
              <el-form-item label="分销权限" v-if="ElementControls('jinshizun')==1&&ElementControls('OMS_card_distributio')==1&&userInfoMd.issupportdis" class="formTimeSlot">
                <el-select v-model="searchClsForm.issupportdis" placeholder="请选择" clearable>
                        <el-option label="全部" value=""></el-option>
                  <el-option label="支持分销" value="1"></el-option>
                  <el-option label="不支持分销" value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="结算方式" v-if="ElementControls('jinshizun')==1" class="formTimeSlot">
                <el-select v-model="searchClsForm.settletype" placeholder="请选择" clearable>
                  <el-option label="月结" value="0"></el-option>
                  <el-option label="现结" value="1"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="会员类别" v-if="ElementControls('jinshizun')==1" class="formTimeSlot">
                <el-select v-model="searchClsForm.saletype" placeholder="请选择" clearable>
                  <el-option label="直客" value="0"></el-option>
                  <el-option label="渠道客户" value="1"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                  <el-button type="primary" @click="getSenderinfoList">查询</el-button>
                  <el-button type="primary" plain @click="getAddMem(0,'0')">新增</el-button>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" plain  @click="importMemberShow = true">批量导入</el-button>
                <el-button type="primary" plain @click="daochu" :loading="exportLoading" v-if="senderinfoList.length>0">导出</el-button>
              </el-form-item>
            </el-form>
            <!-- E头部搜索区域 -->
            <div class="gsListTable individualiz"> 
                <!-- S 分类列表 scope.row.start-->
                <el-table class="comTable lev1Table" ref="lev1Table" :data="senderinfoList" border :max-height="tableHeight" v-loading="vloading">
                    <el-table-column label="序号" type="index" width="60" fixed></el-table-column>
                    <el-table-column label="会员信息" min-width="240" fixed>
                      <template slot-scope="scope">
                        <div class="pdr30">
                          <p class="textFl" :title="scope.row.nickname">
                            <el-tag class="distriTag" v-if="scope.row.issupportdis&&ElementControls('jinshizun')==1&&ElementControls('OMS_card_distributio')==1&&userInfoMd.issupportdis">支持分销</el-tag>
                            {{ scope.row.nickname || '--' }}  
                          </p>
                          <p class="textFl" :title="scope.row.username">
                            <el-tag type="success" v-if="scope.row.issupportdis&&scope.row.openid">已绑微信</el-tag>
                            {{ scope.row.username || '--' }}
                          </p>
                        </div>
                      </template>
                    </el-table-column>  
                    <el-table-column label="联系人" min-width="180" sortable prop="realname">
                    <template slot-scope="scope">
                      <div class="linkWrap pdr30">
                        <p class="textFl iconuser" :title="scope.row.realname">{{scope.row.realname || '--'}}</p>
                        <p class="linkNum">
                        <b v-show="scope.row.mphone" class="iconiPhone" :title="scope.row.mphone">{{scope.row.mphone}}</b>
                        <b v-show="scope.row.tphone" class="icongh" :title="scope.row.tel">{{scope.row.tphone}}</b>
                        </p>
                        <span v-if="!scope.row.mphone && !scope.row.tphone">--</span>
                      </div>
                    </template>
                    </el-table-column>  
                    <el-table-column label="所属店员" v-if="ElementControls('jinshizun')==1 && userInfoMd.objtype==0" min-width="180">
                      <template slot-scope="scope">
                        <p class="textFl pdr70" :title="scope.row.dyname">{{ scope.row.dyname || '--' }}</p>
                      </template>
                    </el-table-column>
                    <el-table-column label="状态" prop="status" sortable min-width="200">
                        <template slot-scope="scope">
                            <p><el-switch disabled :value="scope.row.status ? true :false" :width="45" class="isSwitch" :active-text="scope.row.status?'启':'禁'"></el-switch></p>
                            <small class="greyColor" v-if="ElementControls('jinshizun')==1">注册时间：{{ dateTime(scope.row.regdate) || '--' }}</small>
                        </template>
                    </el-table-column> 
					          <el-table-column label="结算方式" min-width="150" sortable prop="settletype" v-if="ElementControls('jinshizun')==1">
                        <template slot-scope="scope">
                            <p :class="scope.row.settletype ? 'orangeColor' : 'greenColor'">{{scope.row.settletype ? '现结' : '月结' }}</p> 
                        </template>
                    </el-table-column>
					          <el-table-column label="会员类别" min-width="200" sortable prop="saletype" v-if="ElementControls('jinshizun')==1">
                        <template slot-scope="scope">
                            <p>
                              <span :class="scope.row.saletype ? 'redColor' : 'blueColor'">{{scope.row.channelstatus==0?'渠道客户':(scope.row.saletype ? '渠道客户' : '直客') }}</span>
                              <span v-if="scope.row.channelstatus==0 || scope.row.channelstatus==2">
                                【<em :class="scope.row.channelstatus | channelstatusColor">{{scope.row.channelstatus|channelstatusState}}</em>】
                              </span>
                            </p>
                            <small v-if="scope.row.channelstatus==2 && scope.row.examinmemo">备注：{{scope.row.examinmemo}}</small>
                        </template>
                    </el-table-column>   
					          <el-table-column label="总开票金额(￥)" min-width="180" sortable prop="money" v-if="ElementControls('jinshizun')==1">
                        <template slot-scope="scope">
                          <p class="priceFont hand" @click="getShowAllrecord(scope.row)" v-if="scope.row.caninvoiceprice+scope.row.toinvoiceprice+scope.row.hasinvoiceprice > 0"><i class="iconhand"></i>
                          {{(scope.row.caninvoiceprice+scope.row.toinvoiceprice+scope.row.hasinvoiceprice) | formatAmount}}
                          </p>
                          <!-- 注意：金额为0时展示下面的p标签 -->
                          <p class="pl25 priceFont" v-else>0</p>
                        </template>
                    </el-table-column> 
					          <el-table-column label="剩余开票金额(￥)" min-width="180" sortable prop="money" v-if="ElementControls('jinshizun')==1">
                        <template slot-scope="scope">
                            <p class="priceFont greenColor">{{scope.row.caninvoiceprice|formatAmount }}</p>
                        </template>
                    </el-table-column>  
					          <el-table-column label="已申请，待开票金额(￥)" min-width="200" sortable prop="money" v-if="ElementControls('jinshizun')==1">
                        <template slot-scope="scope">
                            <p class="priceFont orangeColor hand" @click="getShowRecord(0,scope.row)" v-if="scope.row.toinvoiceprice>0"><i class="iconhand"></i>{{scope.row.toinvoiceprice|formatAmount }}</p>
                            <!-- 注意：金额为0时展示下面的p标签 -->
                            <p class="pl25 orangeColor priceFont" v-else>0</p>
                        </template>
                    </el-table-column>   
					          <el-table-column label="已开票金额(￥)" min-width="180" sortable prop="money" v-if="ElementControls('jinshizun')==1">
                        <template slot-scope="scope">
                            <p class="priceFont redColor hand" @click="getShowRecord(1,scope.row)" v-if="scope.row.hasinvoiceprice>0"><i class="iconhand"></i>{{scope.row.hasinvoiceprice|formatAmount }}</p>
                            <!-- 注意：金额为0时展示下面的p标签 -->
                            <p class="pl25 redColor priceFont" v-else>0</p>
                        </template>
                    </el-table-column>  
                    <el-table-column label="注册时间" min-width="150" v-if="ElementControls('jinshizun')!=1">
                        <template slot-scope="scope">
                            <span >{{ dateTime(scope.row.regdate) || '--' }}</span>
                        </template>
                    </el-table-column>      
                    <el-table-column label="备注" min-width="180">
                      <template slot-scope="scope">
                        <p class="txtLineTwo pdr30" :title="scope.row.memo">{{scope.row.memo || '--'}}</p>
                      </template>
                    </el-table-column>
                    <el-table-column label="操作" :width="ElementControls('jinshizun')==1?120:100" fixed="right">
                        <template slot-scope="scope">
                            <div class="handle">
                                <span class="detailA" @click="getAddMem(1,scope.row.mcode)" title="详情"><i class="icondetails"></i></span>
                               <span  title="编辑"  @click="getAddMem(2,scope.row.mcode)" v-if="canEdit(scope.row)"><i class="iconedit"></i></span>
                               <span title="解绑微信" @click="getShowRemoveWechat(scope.row.mcode)" v-if="ElementControls('jinshizun')==1&&scope.row.issupportdis&&scope.row.openid"><i class="iconjb"></i></span>
                            </div>
                        </template>
                    </el-table-column>
                    <template slot="empty" v-if="vloading">
                        <div :class="{noData:vloading}"></div>
                    </template>
                    <template slot="empty" v-else>
                      <div class="noData"><span>暂无数据</span></div>
                    </template>
                </el-table>
                <!-- E 分类列表 -->
            </div>
            <!-- S 分页 -->
            <Page :pageTotal="pagebBean.totalnum" :currentPage="currentPage" @nowPageParam="updatePage"></Page>
            <!-- E 分页 -->
        </div>

		<!-- S 新增会员 -->
    <AddNewMember :memberAddDialogVisible="memberAddDialogVisible" :indexnumber="indexnumber" :membercode="membercode" @closeAddMem="getCloseAddMeb"></AddNewMember>
		<!-- E 新增会员 -->

		<!-- S 金额操作记录 -->
    <div v-if="recordDlog">
		<el-dialog class="comDlog recordDlog" :visible.sync="recordDlog" :before-close="getCloseRecord" :modal-append-to-body="false" append-to-body :close-on-click-modal="false">
		  <div slot="title" class="flexUpDownCenter">{{recordIndex?'已开票记录':'待开票记录'}}
				<dl class="flexUI recordDl">
					<dt>会员信息：</dt>
					<dd>
						<span class="textFl name200">{{listmember.nickname || '--' }}</span>{{listmember.mphone ||listmember.tphone ||'--'}}
					</dd>
					<dd>剩余可开票金额：<span>￥{{listmember.caninvoiceprice|formatAmount}}</span></dd>
				</dl>
			</div>
    	<BillingRecord  :listmember="listmember" :recordIndex="recordIndex" :status="recordIndex?['1','3']:['0']"> </BillingRecord>
			<span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="getCloseRecord">关闭</el-button>
            </span>
		</el-dialog>
    </div>
		<!-- E 金额操作记录 -->
		<!-- S 总开票金额记录 -->
    <div v-if="allrecordDlog">
      <el-dialog class="comDlog recordDlog" :visible.sync="allrecordDlog" :before-close="getCloseAllrecord" :modal-append-to-body="false" append-to-body :close-on-click-modal="false">    
	      <div slot="title" class="flexUpDownCenter">销售单记录
          <dl class="flexUI recordDl">
            <dt>会员信息：</dt>
            <dd>
              <span class="textFl name200">{{listmember.nickname || '--' }}</span>{{listmember.mphone ||listmember.tphone ||'--'}}
            </dd>
            <dd>总开票金额：<span>￥{{(listmember.caninvoiceprice+listmember.toinvoiceprice+listmember.hasinvoiceprice) | formatAmount}}</span></dd>
          </dl>
        </div>
        <OrderSales  :listmember="listmember"></OrderSales>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="getCloseAllrecord">关闭</el-button>
        </span>
      </el-dialog>
    </div>
		<!-- E 总开票金额记录 -->

    <!--S 批量导入弹窗-->
    <el-dialog :visible.sync="importMemberShow" class="comDlog printDlg" :close-on-click-modal="false" append-to-body :before-close="getCloseImport">
      <div slot="title" class="dialog-title">批量导入</div>
      <el-form label-width="160px">
        <el-form-item class="allWidth" label-width="50px">
          <p class="breathTit iconbulb">请事先整理好要批量导入的会员列表，导入文件请遵循必填要求；另外，单次导入数据不可超过<b class="redColor">5000条</b> <el-link type="primary" :underline="false" href="https://presale.jhtsoft.com/%E7%A4%BA%E4%BE%8B%E6%96%87%E4%BB%B6/%E4%BC%9A%E5%91%98.xlsx"><i class="icondownload"></i>下载示例文件</el-link></p>
        </el-form-item>
        <el-form-item label="选择上传文件" required>
          <el-upload class="upload-demo" name="files" :action="uploadUrl" :on-success="updSuccess" :on-remove="handleRemove" :accept="'.xls,.xlsx'" :before-upload="beforeAvatarUpload" :before-remove="beforeRemove" :limit="1" :on-exceed="handleExceed" :file-list="fileList">
            <el-button v-show="!fileUrl" type="primary" plain>点击上传</el-button>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="getCloseImport(1)" :loading="isLoading">确定</el-button>
        <el-button @click="getCloseImport(0)">取消</el-button>
      </div>
    </el-dialog>
    <!--E 批量导入弹窗-->

    </div>
</template>
<script>
import Api from '@/apis/api.js';
import Vue from "vue";
import { Message, MessageBox } from "element-ui";
export default {
    name:'MemberList',
    //  *********************************************************************组件
    components: {
      BillingRecord: resolve => require(["./BillingRecord.vue"],resolve),//开票记录
      OrderSales: resolve => require(["./OrderSales.vue"],resolve),//销售单列表
      Page: resolve => require(["@/components/common/Page.vue"], resolve),
      AddNewMember: resolve => require(["@/components/common/AddNewMember.vue"], resolve),//新增会员组件
    },
    //   *********************************************************************变量
    data() {
      return {
        userInfoMd: "", //登录信息
        indexnumber:-1,//操作类型:0:新增，1：详情；2：编辑
        membercode:'',//会员编号
        memberAddDialogVisible: false, //新增会员弹框
        vloading:false,//加载中
        searchClsForm: {
          keyword: '',
          status:'', //状态
          usetype:'',
          issupportdis:"",//是否可分销
          settletype:"",//结算方式
          saletype:"",//会员类别
        }, 
        tableHeight: window.innerHeight*.8, //表格动态高度
        senderinfoList:[],//列表信息
        pageSize: 30, // 每页展示的条数
        currentPage: 1, // 当前请求的页数
        pagebBean: {
          totalnum: 0,
        }, // 获取到的列表分页信息        
        recordDlog:false,//开票记录弹窗
        recordIndex:0,//0：待开票 1：已开票
        allrecordDlog:false,//总开票金额记录弹窗
        tableHeight: window.innerHeight * 0.8,
        listmember:'',
        //--------------------------------------批量导入会员 S------------
        importMemberShow:false,//批量导入
        fileUrl:'',//文件地址
        fileList: [],
        uploadUrl: Api.UPLOADFILE(),
        isLoading:false,//上传中
        //--------------------------------------批量导入会员 E------------
        
        exportLoading: false,// 导出加载中
      }
    },
    	filters: {
		// 审核状态颜色过滤
		channelstatusColor(val){
			return [
				{orangeColor:val == 0},
				{blueColor:val == 1},
				{redColor:val == 2},
				{greyColor:val == 3},
			]
		},
		// 审核状态过滤
		channelstatusState(val){
			if(val == 0){
				return '待审核'
			}else if(val == 1){
				return '审核通过'
			}else if(val == 2){
				return '审核失败'
			}else if(val == 3){
				return '无需审核'
			}else{
         return '--'
      }
		},
	},
    //   *********************************************************************方法
    methods: {
      canEdit(row) {
        if (!this.userInfoMd || !row) {
          return false;
        }
        const isOwner = row.ownercode === this.userInfoMd.flowcode;
        const isSharedMember = this.userInfoMd.bsharemember === 1;
        const isMemberAff = row.memberaff === 1;
        return isOwner && (isSharedMember || isMemberAff);
      },
      // 解除微信绑定弹框 ---------------------------------------------------------------- 2024/08/26
      getShowRemoveWechat(membercode){
        MessageBox.confirm('确定需要解绑微信吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let params = {
            membercode:membercode
          }
          Api.MBUNBINDWX(params).then((res) => {
              if(res.data.status == '200'){
                this.$message({
                  type: 'success',
                  message: res.data.message
                })
                this.getSenderinfoList();
              }else{
                this.$message.error(res.data.message)
              }
          })
        }).catch(() => {});
      },
      //------------------------------------------------批量导入会员  2024-3-5 start---------
      //批量导入
      updSuccess(res, files, fileList) {
        if (res.flag) {
          this.fileList = [];
          this.fileList.push(files);
          this.fileUrl = res.url;                
        } else {
          this.$message.error(res.message)
          this.fileList = [];
          this.fileUrl = '';
        }
      },
      //删除文件
      handleRemove(file, fileList) {
        this.fileList = [];
        this.fileUrl = '';
      },
      //删除队列文件
      beforeRemove(file, fileList) {
        if(file.raw.type == 'application/vnd.ms-excel' || file.raw.type == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'){
          // return this.$confirm(`确定移除 ${ file.name }？`, '提示', {
          //   type: 'warning'
          // }).then(() => {
          //   this.fileList = [];
          //   this.fileUrl = '';
          // }).catch(() => {
          // });
          return new Promise((response,reject) => {
            this.$confirm(`确定移除 ${ file.name }？`, '提示', {
              type: 'warning'
            }).then(() => {
                this.fileList = [];
                this.fileUrl = '';
                return response()
            }).catch(() => {
                return reject()
            });
          })
        }
      },
      handleExceed(files, fileList) {
        this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
      },
      //上传文件类型限制
      beforeAvatarUpload(file) {
        let isExcel = false;
        if(file.type == 'application/vnd.ms-excel' || file.type == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'){
          isExcel = true
        }
        if (!isExcel) {
          this.fileList=[];
          this.fileUrl = '';
          this.$message.error('请选择对应的.xls/.xlsx文件上传！');
        }
        return isExcel
      },
      //批量导入会员
      getCloseImport(val){
        if(val==1){
          if(this.fileUrl == ''){
            this.$message.error('请上传导入文件！');
            return false
          }
          this.isLoading = true;
          Api.IMPORTMEMBERS({url:this.fileUrl}).then(res => { 
            if(res.data.status == "200") {
              this.$message({
                type: 'success',
                message: res.data.message
              })
              this.vloading = true;////防止数据量过大先loading
              setTimeout(() => {
                this.getSenderinfoList();
              }, 250);
              this.importMemberShow = false;
              this.fileUrl = "";
              this.fileList = [];
              setTimeout(() => {
                this.isLoading = false;
              }, 2);
            } else {
              this.$message({
                type: 'error',
                message: res.data.message
              })
              this.isLoading = false;
            }
          }).catch(res => {
            this.isLoading = false;
          })
        }else{
          this.importMemberShow = false;
          this.fileUrl = "";
          this.fileList=[];
        }
      },
      //------------------------------------------------批量导入会员  2024-3-5 end---------
      //导出
      daochu(){
        this.exportLoading = true;
        let param = {
          bsharemember:this.userInfoMd.bsharemember,
          usetype:this.searchClsForm.usetype,
          keyword:this.searchClsForm.keyword,
          status:this.searchClsForm.status!==''?Number(this.searchClsForm.status):'',
          issupportdis:this.searchClsForm.issupportdis!==''?Number(this.searchClsForm.issupportdis):'',
        }
        if(this.ElementControls('jinshizun')==1){
          Vue.set(param,'settletype',this.searchClsForm.settletype);
          Vue.set(param,'saletype',this.searchClsForm.saletype);
          // Vue.set(param,'risktype',Number(this.searchClsForm.risktype));
        }
        Api.EXPORTMEMBERLIST(param).then(res =>{
          if (res.data.status == '200') {
            if (res.data.data) {
                window.location.href = res.data.data
            }
            Message({
              type: 'success',
              message: res.data.message
            });
          } else {
            Message({
              type: 'error',
              message: res.data.message
            });
          }
          this.exportLoading = false;
        }).catch(err =>{
          this.exportLoading = false;
        })
      },

      // 新增/编辑会员弹窗
      getAddMem(index,membercode) {
        this.indexnumber =index;
        this.membercode = membercode;
        if(index == 1) {
          this.$router.push({
            name:'会员详情',
            path:'/MemberDetail',
            params:{
              membercode: membercode
            }
          })
        } else {
          this.memberAddDialogVisible = true;
        }
      },
      //关闭新增会员弹窗
      getCloseAddMeb(val){
        this.memberAddDialogVisible = false;
        if(val==1){
          this.getSenderinfoList();
        }
      },
      //获取列表信息
      getSenderinfoList() {
        let params = {
          settletype:this.searchClsForm.settletype!==''?Number(this.searchClsForm.settletype) :'',
          saletype:this.searchClsForm.saletype!==''?Number(this.searchClsForm.saletype) :'',
          bsharemember:this.userInfoMd.bsharemember,
          usetype:this.searchClsForm.usetype,
          keyword:this.searchClsForm.keyword,
          status:this.searchClsForm.status!==''?Number(this.searchClsForm.status):'',
          issupportdis:this.searchClsForm.issupportdis!==''?Number(this.searchClsForm.issupportdis):'',
          pageparam:{
            pagesize: this.pageSize, //每页条数
            currentpage: this.currentPage, //当前页数
            isnewcomp: 1 //是否需要重新统计页数
          }
        }
        this.vloading = true;
        Api.GET_MEMBERLIST(params).then((res) => {
          if(res.data.status == "200"){
            this.vloading = false;
            this.senderinfoList = res.data.data;
            if(res.data.pagebean){
                this.pagebBean = res.data.pagebean
            }
          }
        })
      },
      // 接收分页信息
      updatePage(size,num) {
          this.pageSize = size;
          this.currentPage = num;
          this.getSenderinfoList();
      },
      //动态获取表格高度
      getHeight() {
          let tbHeight = this.$refs.lev1Table.$el.offsetTop; //顶部检索条件占据的高度
          this.tableHeight = window.innerHeight - tbHeight - 120; 
      },
      // S ------------------ 开票记录弹窗 ------------------

      // 打开总开票记录弹窗
      getShowAllrecord(item){
        this.listmember = item;
        this.allrecordDlog= true;
      },
      // 关闭总开票记录弹窗
      getCloseAllrecord(){
        this.allrecordDlog = false;
      },
      // 打开开票记录弹窗
      getShowRecord(val,item){
        this.listmember = item;
        this.recordIndex = val;
        this.recordDlog = true;
      },
      // 关闭开票记录弹窗
      getCloseRecord(){
        this.recordDlog = false;
      },
      
    },
    created() {
      //页面浏览器视窗变化绑定resize事件
      window.addEventListener("resize", this.getHeight);
    },
    //   *********************************************************************初始化
    mounted(){
      if(localStorage.getItem('userInfoMd')&&localStorage.getItem('userInfoMd')!='null'){
        this.userInfoMd = 	JSON.parse(localStorage.getItem('userInfoMd'))
      }
      setTimeout(()=>{
        this.getHeight();
      },200)
      this.getSenderinfoList();// 获取列表信息
    },
    destroyed(){ 
      window.removeEventListener('resize', this.getHeight); //销毁监听浏览器视窗变化
    },
    activated() {
      if(localStorage.getItem('userInfoMd')&&localStorage.getItem('userInfoMd')!='null'){
        this.userInfoMd = 	JSON.parse(localStorage.getItem('userInfoMd'))
      }
      if(this.patchName != '会员详情') {
        if(this.patchName) {
          window.location.reload()
        }
      }
    },

}
</script>
<style scoped>
.mainPart {padding: 20px; height: calc(100% - 50px);}
.textHidenP {margin-right: 50px; max-width: 500px;}
.searchForm {padding-top: 14px;}
.w200{width:200px;} 
.comTable >>> .el-tag {display:inline-block;height: 16px; padding: 0 2px;line-height: 14px; font-size: 12px;}
/*金额操作记录 */
.recordDlog>>>.el-dialog{min-width: 1400px;width: 80%;}
.recordDlog>>>.el-dialog__body{height: 580px!important;}
.pdr30{padding-right: 30px;}
.hand{cursor: pointer;}
.hand i{font-size: 20px;margin-right: 5px;vertical-align: bottom;color: #666!important;}
.recordDl{padding-left: 40px;font-size: 14px;}
.recordDl dd{color: #999;margin-right: 20px;}
.recordDl dd span {cursor: text;}
.name200 {display:inline-block;width:auto;max-width:150px;vertical-align: top; margin-right:10px;font-weight: normal;color:#999;}
.recordDl dd span:not(.name200) {color:#FA2F2F; font-weight: normal;}
.pl25{padding-left: 25px;}
.orderContentI i {font-size: 18px;}
.orderContentI i:hover {color:var(--main-color)}
.creditIcon em{
    display: block;
    color: #333;
    font-size: 14px;
    margin: 5px 0;
}
.creditIcon em i{
    display: inline-block;
    height: 20px;
    width: 20px;
    color: #fff;
    border-radius: 50%;
    text-align: center;
    font-size: 12px;
    line-height: 20px;
    margin-left: 5px;
}
.creditIcon em .remainIcon{
    background: #f56262;
}
.creditIcon em .usedIcon{
    background: #f2962c;
}
.creditIcon em .totalIcon{
    background: var(--main-color);
}
.creditIcon em strong{
    min-width: 80px;
    text-align: left;
    display: inline-block;
    font-weight: 700;
}
/*星标客户 start */
.el-table .cell {position:relative;}
.cell .iconstarsign{position:absolute; top:1px; left:-25px; font-size: 30px; color: #FFAE48;}
/*星标客户 end */
/*批量导入弹窗 start*/
.printDlg >>> .el-dialog {width:650px;}
.printDlg >>> .el-form-item:last-child {margin-bottom:0;}
.printDlg .breathTit.iconbulb {width:85%;}
.printDlg >>> .el-link.el-link--primary {line-height:1; font-size: 12px;padding-left:15px;}
.printDlg >>> .el-upload-list{display: inline-block; vertical-align: top;}
.printDlg >>> .el-upload-list__item:first-child {margin-top:0;margin-left:10px;line-height:40px;}
.printDlg >>> .el-upload-list__item .el-icon-close {line-height:30px;}
.printDlg >>> [class*="el-icon-"]:not(.el-icon-close-tip), .printDlg >>> [class^="el-icon-"]:not(.el-icon-close-tip) {font-size: 20px;}
/*批量导入弹窗 end*/
</style>



// WEBPACK FOOTER //
// src/views/ManageFolder/PlatformUser/MemberList.vue